const handleErrorMessages = (error, silenceUserNotLoggedError) => {
    if (!error || typeof error !== 'object') {
        return []
    }
      const { code, description, errors, status } = error
      if (errorsIsEmpty(errors) && !description && !code) {
        return ['Generic server error']
      }

      if (errorsIsEmpty(errors) && !description && code) {
        return [code]
      }

      if (errorsIsEmpty(errors) && code && description) {
        if (code === 'USER_NOT_LOGGED' && status === 403) {
          return silenceUserNotLoggedError ? [] : ['Session has been expired. Please log in again']
        }
          return [description]
      }

      const msg = Object.keys(errors).reduce((acc, key) => {
        return acc.add(errors[key])
      }, new Set())

      return [...msg]
}

const errorsIsEmpty = (errors) => (!errors || Object.keys(errors).length === 0)

export default handleErrorMessages
